
<template>
  <div class>
    <!-- ERROR MODAL -->
    <div>
      <b-modal ref="errorModal" id="errorModal" title="Something Went Wrong!">
        <p class="my-4">{{ errorMessage }}</p>
      </b-modal>
    </div>

    <div id="overlay">
      <div id="text">Importing Database...</div>
    </div>

    <div class="jm-white-container">
      <div class="col-lg-10 mx-auto">
        <div class="row">
          <div class="col-md-6 d-flex mb-3">
            <div class="w-100">
              <div class="input-container">
                <input
                  v-model="DatabaseDetails.hostName"
                  type="text"
                  placeholder="Server / Hostname"
                />
              </div>
              <p
                v-if="errorMessageStatus.hostName"
                class="error_msg"
              >Server / Hostname Cannot be empty</p>
            </div>
  
            <Tooltip :title="`The name or IP Address of the server where your mysql database is setup`" :classname="`mt-3`" />
          </div>

          <div class="col-md-6 d-flex mb-3">
            <div class="w-100">
              <div class="input-container">
                <input v-model="DatabaseDetails.portNumber" type="text" placeholder="Port" />
              </div>
              <p v-if="errorMessageStatus.portNumber" class="error_msg">Invalid Port</p>
            </div>
            <Tooltip :title="`The TCP/IP port on which the MySQL server is listening`" :classname="`mt-3`" />
          </div>

          <div class="col-md-6 d-flex mb-3">
            <div class="w-100">
              <div class="input-container">
                <input v-model="DatabaseDetails.userName" type="text" placeholder="Username" />
              </div>
              <p v-if="errorMessageStatus.userName" class="error_msg">Invalid Username</p>
            </div>
            <Tooltip :title="`MySQL user's username`" :classname="`mt-3`" />
          </div>

          <div class="col-md-6 d-flex mb-3">
            <div class="w-100">
              <div class="input-container">
                <input v-model="DatabaseDetails.password" type="password" placeholder="Password" />
              </div>
              <p v-if="errorMessageStatus.password" class="error_msg">Invalid Password</p>
            </div>
            <Tooltip :title="`MySQL user password`" :classname="`mt-3`" />
          </div>

          <div class="col-md-6 d-flex mb-3">
            <div class="w-100">
              <div class="input-container">
                <input
                  v-model="DatabaseDetails.databaseName"
                  type="text"
                  placeholder="Database Name"
                />
              </div>
              <p v-if="errorMessageStatus.databaseName" class="error_msg">Invalid Database Name</p>
            </div>
            <Tooltip :title="`MySQL Database name`" :classname="`mt-3`" />
          </div>

          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4">
                <router-link class="btn-outline-blue-lg w-100" to="select-installation-type">Back</router-link>
              </div>
              <div class="col-md-4 d-flex align-items-center">
                <router-link
                  v-on:click.native="onCheckConnection()"
                  class="btn-grey-lg w-100"
                  :class="checkValidation() ? '' : 'disabled'"
                  to="#"
                >Check Connection</router-link>
                <Tooltip :title="`Click to test your MySQL database connection.`"  />
              </div>
              <div class="col-md-4">
                <router-link
                  v-on:click.native="onClickProceed()"
                  class="btn-blue-lg w-100"
                  to="#"
                  :class="checkValidation() ? '' : isCheckingConnection || isConnectionError ? 'disabled':''"
                >Proceed</router-link>
                <!-- to="backup-configuration" -->
              </div>
            </div>
          </div>

          <div
            v-if="isCheckingConnection"
            class="col-md-12 mt-3 text-center d-flex align-items-center justify-content-center"
          >
            <span class="loader-sm"></span>
            &nbsp; Checking Connecton. Please Wait for a moment
          </div>
          <div
            v-if="isConnectionEstablished"
            class="col-md-12 mt-3 text-center d-flex align-items-center justify-content-center text-success"
          >&nbsp;Connection Established</div>
          <div
            v-if="isConnectionError"
            class="col-md-12 mt-3 text-center d-flex align-items-center justify-content-center text-danger"
          >&nbsp; Error While Creating Connection</div>
        </div>
      </div>
    </div>
  </div>
</template>
 

 <script>
import CheckConnectionService from "@/services/CheckConnectionService.js";
import SetupService from "@/services/SetupService";

export default {
  name: "Database Configuration",

  data() {
    return {
      DatabaseDetails: {
        /*hostName: "localhost",
        portNumber: "3306",
        userName: "yogesh",
        password: "yogesh123",
        databaseName: "cinematic"*/
        hostName: "localhost",
        portNumber: "3306",
        userName: "root",
        password: "root",
        databaseName: "cinematic"
      },
      errorMessageStatus: {
        hostName: false,
        portNumber: false,
        userName: false,
        password: false,
        databaseName: false
      },
      errorMessage: "",
      isCheckingConnection: false,
      isConnectionEstablished: false,
      isConnectionError: false,
      isDBImporting: true
    };
  },
  methods: {
    checkValidation: function() {
      if (
        this.DatabaseDetails.hostName == null ||
        this.DatabaseDetails.hostName == ""
      ) {
        this.errorMessageStatus.hostName = true;
        return false;
      } else if (
        this.DatabaseDetails.portNumber == null ||
        this.DatabaseDetails.portNumber == ""
      ) {
        this.errorMessageStatus.portNumber = true;
        return false;
      } else if (
        this.DatabaseDetails.userName == null ||
        this.DatabaseDetails.userName == ""
      ) {
        this.errorMessageStatus.userName = true;
        return false;
      } else if (
        this.DatabaseDetails.password == null ||
        this.DatabaseDetails.password == ""
      ) {
        this.errorMessageStatus.password = true;
        return false;
      } else if (
        this.DatabaseDetails.databaseName == null ||
        this.DatabaseDetails.databaseName == ""
      ) {
        this.errorMessageStatus.databaseName = true;
        return false;
      } else {
        this.errorMessageStatus.hostName = false;
        this.errorMessageStatus.portNumber = false;
        this.errorMessageStatus.userName = false;
        this.errorMessageStatus.password = false;
        this.errorMessageStatus.databaseName = false;
        return true;
      }
    },
    onCheckConnection: function() {
      if (this.checkValidation()) {
        this.isCheckingConnection = true;
        let payload = this.DatabaseDetails;
        CheckConnectionService.CheckConneciton(payload)
          .then(response => {
            const { data } = response;
            if (data.Status) {
              this.isConnectionEstablished = true;
              this.isCheckingConnection = false;
              this.isConnectionError = false;
            } else {
              this.isCheckingConnection = false;
              this.isConnectionEstablished = false;
              this.isConnectionError = true;
            }
          })
          .catch(error => {
            this.isCheckingConnection = false;
            this.isConnectionEstablished = false;
            this.isConnectionError = true;
          });
      }
    },
    onClickProceed: function() {
      if (this.checkValidation()) {
        document.getElementById("overlay").style.display = "block";
        let payload = this.DatabaseDetails;
        SetupService.addCinemaDB(payload)
          .then(response => {
            const { data } = response;
            if (data.status) {
              document.getElementById("overlay").style.display = "none";
              this.$router.push({
                // to="cinema-concession-levels"
                path: "cinema-concession-levels"
              });
            } else {
              document.getElementById("overlay").style.display = "none";
              this.errorMessage = res.data.Message.sqlMessage;
              this.$refs.errorModal.show();
            }
          })
          .catch(error => {
            document.getElementById("overlay").style.display = "none";
            this.errorMessage = "Please contact your admin";
            this.$refs.errorModal.show();
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cinemaInstallation/cinemaDataBaseConfiguration.vue